// extracted by mini-css-extract-plugin
export default {"container":"SlopeTimeExceedAlertModal_container__8v9jU","red":"SlopeTimeExceedAlertModal_red__e2ZOV","buttons":"SlopeTimeExceedAlertModal_buttons__h-eFJ"};